import { ASSET_PATHS } from '../../utils/assetPath';

import './WarningIcon.css';

interface WarningIconProps {
  className?: string;
  size?: number;
  ariaLabel?: string;
}

function WarningIcon({ className = '', size = 18, ariaLabel = 'Warning' }: WarningIconProps) {
  return (
    <img
      alt=''
      aria-label={ariaLabel}
      className={`warning-icon ${className}`}
      height={size}
      src={ASSET_PATHS.WARNING_ICON}
      width={size}
    />
  );
}

export default WarningIcon;
